<template>
  <el-select
    filterable
    :clearable="clearable"
    default-first-option
    :filter-method="filterMethod"
    @focus="focusBrand"
    @change="changeBrand"
    :size="size"
    :value="value"
    style="width: 100%"
    :placeholder="placeholder"
    :multiple="multiple"
    collapse-tags
  >
    <el-option v-for="item in brandList" :key="item[valueProp]" :value="item[valueProp]" :label="item[labelProp]"></el-option>
  </el-select>
</template>

<script>
export default {
  name: 'BrandSelect',
  props: {
    size: String,
    value: [String, Number, Array],
    data: {
      type: Array,
      required: true,
    },
    placeholder: String,
    clearable: Boolean,
    multiple: Boolean,
    labelProp: {
      type: String,
      default: 'englishName',
    },
    valueProp: {
      type: String,
      default: 'brandId',
    },
  },
  data() {
    return {
      brandList: [],
    };
  },
  watch: {
    data(list) {
      this.init(list);
    },
    value(val) {
      let brandList = this.data.slice(0, 500);
      if (this.multiple && val) {
        val.forEach((v) => {
          if (!brandList.some((item) => item[this.valueProp] === v)) {
            brandList = brandList.concat(
              this.data.filter((item) => {
                if (item[this.valueProp] === v) {
                  return true;
                }
                return false;
              })[0],
            );
          }
        });
      } else if (!brandList.some((item) => item[this.valueProp] === this.value)) {
        brandList = brandList.concat(
          this.data.filter((item) => {
            if (item[this.valueProp] === val) {
              return true;
            }
            return false;
          }),
        );
      }
      this.brandList = brandList;
    },
  },
  mounted() {
    this.init(this.data);
  },
  methods: {
    init(list) {
      let brandList = list.slice(0, 500);
      if (this.multiple && this.value) {
        this.value.forEach((val) => {
          if (!brandList.some((item) => item[this.valueProp] === val)) {
            brandList = brandList.concat(
              list.filter((item) => {
                if (item[this.valueProp] === val) {
                  return true;
                }
                return false;
              })[0],
            );
          }
        });
      } else if (!brandList.some((item) => item[this.valueProp] === this.value)) {
        brandList = brandList.concat(
          list.filter((item) => {
            if (item[this.valueProp] === this.value) {
              return true;
            }
            return false;
          }),
        );
      }
      this.brandList = brandList;
    },
    changeBrand(val) {
      this.$emit('input', val);
      this.$emit('change', val);
    },
    filterMethod(query) {
      if (query) {
        const data = [];
        this.data.filter((item) => {
          const name = item[this.labelProp].toUpperCase();
          const str = query.toUpperCase();
          if (name.startsWith(str) && data.length < 500) {
            // if (name.indexOf(str) >= 0 && data.length < 500) {
            data.push(item);
            return true;
          }
          return false;
        });
        this.brandList = data;
      } else {
        this.brandList = this.data.slice(0, 500);
      }
    },
    focusBrand() {
      this.brandList = this.data.slice(0, 500);
    },
  },
};
</script>

<style scoped lang="scss"></style>
